import { ProductTileClickImpressionContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/ProductTileClickImpressionContext";
import { useContext } from "react";
export var useProductTileClickImpressionContext = function() {
    return useContext(ProductTileClickImpressionContext);
};
